const resultTypes = {
  CATEGORIES:  'resultcategories',
  SCORE_RANGE: 'resultscorerange',
};

resultTypes.ALL = _.values(resultTypes);

export default resultTypes;
